import { Component, Inject, OnInit,  } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RecordService } from '../../../../services/record.service';
import { get } from 'lodash-es';
import { LooseObject } from '../../../../objects/loose-object';
import { filled } from '../../../../shared/utils/common';

@Component({
  selector: 'app-scheduler-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {

  bShowLoader: boolean = false;

  strRecordId?: string|null = null;

  strSchedulerId?: string|null = null;

  strSchedulerTaskNotes?: string|null = null;

  constructor(
    protected recordService: RecordService,
    protected dialogRef: MatDialogRef<NotesComponent>,
    @Inject(MAT_DIALOG_DATA) protected dialogData,
  ) {
  }

  ngOnInit() {
    this.strRecordId = get(this.dialogData, 'id', null);
    this.strSchedulerId = get(this.dialogData, 'scheduler_id', null);
    this.strSchedulerTaskNotes = get(this.dialogData, 'note', null);
  }

  closeDialog(response: LooseObject = {}): void {
    this.dialogRef.close(filled(response) ? response : {
      action: 'close'
    });
  }

  onSubmit(): void {
    this.dialogRef.close({
     note: this.strSchedulerTaskNotes,
     scheduler_id: this.strSchedulerId,
    });
  }
}